export default __webpack_public_path__ + "static/social_card_home-8f86166ab3aa9375089df5097e6a836c.png";